import axios from 'axios';

class TrackService {
    getTracks(jwt){
        return axios.post('/api/track/findAll', "", {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+jwt
          }
        });
    }

    searchTrack(jwt, searchTerm){
        const json = JSON.stringify({searchTerm: searchTerm});
        return axios.post('/api/track/search', json, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer '+jwt
            }
          });
    }

    getTrackById(jwt, trackId){
        const json = JSON.stringify({id: trackId});
        return axios.post('/api/track/findById', json, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer '+jwt
            }
          });
    }
}

export default new TrackService()